import { Card, CardContent } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';

export default function Report() {
    return (
        <Card className='mx-1'>
            <CardContent>
                <BarChart
                    xAxis={[{ scaleType: 'band', data: ['group A', 'group B', 'group C'] }]}
                    series={[{ data: [4, 3, 5] }, { data: [1, 6, 3] }, { data: [2, 5, 6] }]}
                    height={400}
                />
            </CardContent>
        </Card>
    )
}
